import { Environment } from "./environments";

export function gTag() {
  const startComment = document.createComment("Google Tag Manager");
  document.head.appendChild(startComment);
  if (Environment.getBuildType() == "prod") {
    const script = document.createElement("script");
    script.innerHTML = `
    (function(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-MKLTBJ2X');
  `;
    document.head.appendChild(script);
  }
  const endComment = document.createComment("End Google Tag Manager");
  document.head.appendChild(endComment);
}
export function gTagOne() {
  if (Environment.getBuildType() == "prod") {
    const gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtag/js?id=G-PEM4XQFM1H";

    const gtmConfigScript = document.createElement("script");
    gtmConfigScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-PEM4XQFM1H");
  `;
    document.head.appendChild(gtmScript);
    document.head.appendChild(gtmConfigScript);
  }
}
export function noScriptTag() {
  const startComment = document.createComment("Google Tag Manager (noscript)");
  const endComment = document.createComment(
    "End Google Tag Manager (noscript)"
  );
  document.body.insertBefore(endComment, document.body.firstChild);
  if (Environment.getBuildType() == "prod") {
    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id=GTM-MKLTBJ2X";
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscript.appendChild(iframe);

    document.body.insertBefore(noscript, document.body.firstChild);
  }
  document.body.insertBefore(startComment, document.body.firstChild);
}
